import React, { useEffect, useState, useRef } from "react";

const AnimatedNumber = ({ target, inView }: { target: number; inView: boolean }) => {
    const [count, setCount] = useState(0);
    const [hasAnimated, setHasAnimated] = useState(false);

    useEffect(() => {
        if (!inView || hasAnimated) return;

        let start = 0;
        const duration = 2000;
        const intervalTime = 50;
        const steps = duration / intervalTime;
        const increment = target / steps;

        const counter = setInterval(() => {
            start += increment;
            if (start >= target) {
                setCount(target);
                clearInterval(counter);
                setHasAnimated(true);
            } else {
                setCount(Math.floor(start));
            }
        }, intervalTime);

        return () => clearInterval(counter);
    }, [target, inView, hasAnimated]);

    return <span>{count.toLocaleString()}</span>;
};

const stats = [
    { "target": 150, "label": "Satisfied Clients" },
    { "target": 250, "label": "Successful Projects" },
    { "target": 100, "label": "Skilled Professionals" },
    { "target": 26, "label": "Years of Experience" }
];

const NumbersCard = () => {
    const [inView, setInView] = useState(false);
    const [hasAnimated, setHasAnimated] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !hasAnimated) {
                    setInView(true);
                    setHasAnimated(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.5 }
        );

        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, [hasAnimated]);

    return (
        <div className="stats-container-wrapper" ref={ref}>
            <div className="stats-container">
                {stats.map((stat, index) => (
                    <React.Fragment key={index}>
                        <div className="stat-item">
                            <div className="stat-text">
                                <p className="stat-number">
                                    <AnimatedNumber target={stat.target} inView={inView} /> +
                                </p>
                                <p className="stat-label">{stat.label}</p>
                            </div>
                        </div>
                        {index < stats.length - 1 && <div className="stat-item-separator"></div>}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default NumbersCard;
